import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const galleryImages = [
  {
    src: "/Images/project1.webp",
    alt: "Rope access work in an industrial environment",
    label: "Rope access work in an industrial environment",
    tag: "Industrial environment",
  },
  {
    src: "/Images/project2.webp",
    alt: "Technical work at height",
    label: "Technical work at height",
    tag: "Work at height",
  },
  {
    src: "/Images/project3.webp",
    alt: "Access support in hard-to-reach areas",
    label: "Access support in hard-to-reach areas",
    tag: "Access support",
  },
  {
    src: "/Images/project4.webp",
    alt: "Work-at-height conditions on site",
    label: "Work-at-height conditions on site",
    tag: "Site conditions",
  },
  {
    src: "/Images/project5.webp",
    alt: "Industrial project environment",
    label: "Industrial project environment",
    tag: "Industrial project",
  },
  {
    src: "/Images/project6.webp",
    alt: "Technical project support",
    label: "Technical project support",
    tag: "Technical support",
  },
];

const Gallery = () => {
  return (
    <section id="gallery" className="section-spacing section-muted gallery-section">
      <Container>
        <Row className="mb-5 align-items-end">
          <Col lg={8}>
            <p className="section-kicker">Gallery</p>
            <h2 className="section-title">Selected Rope Access Work</h2>
            <p className="lead mb-0 section-lead">
              A selection of work environments showing practical rope access,
              work-at-height conditions, and technical project support in
              industrial and construction settings.
            </p>
          </Col>
        </Row>
        <Row className="g-4">
          {galleryImages.map((image) => (
            <Col sm={6} lg={4} key={image.src}>
              <figure className="gallery-item mb-0">
                <img loading="lazy" src={image.src} alt={image.alt} />
                <figcaption className="gallery-caption">
                  <span>{image.label}</span>
                  <small>{image.tag}</small>
                </figcaption>
              </figure>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Gallery;